"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.checkAndSet = void 0;
var _react = _interopRequireDefault(require("react"));
var _formatSpecialCharText = _interopRequireDefault(require("./formatSpecialCharText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const tags = ["<p", "<a", "<im", "<h1", "<h2", "<h3", "<h4", "<h5", "<h6", "<di", "<sp", "<ul", "<ol", "<li", "<a ", "<ta"];
const checkForDangerouslySet = text => {
  if (typeof text !== "string") {
    return false;
  }
  if (text?.length >= 3) {
    const substring = text?.substring(0, 2);
    let set = false;
    tags.forEach(tag => {
      if (substring === tag || tag.startsWith(substring)) {
        set = true;
      }
    });
    return set;
  }
};
var _default = checkForDangerouslySet;
exports.default = _default;
const checkAndSet = (text, classNamePrefix, classNameSuffix, color) => {
  if (checkForDangerouslySet(text)) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `${classNamePrefix}__${classNameSuffix || "text-holder"}`,
      style: {
        color: color || "#242D2F"
      },
      dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(text)
    });
  } else {
    return /*#__PURE__*/_react.default.createElement("p", {
      className: `${classNamePrefix}__${classNameSuffix || "text"}`,
      style: {
        color: color || "#242D2F"
      }
    }, text);
  }
};
exports.checkAndSet = checkAndSet;